import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, Select, Input, Modal, Checkbox, Button } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { getPastDateByYears, isRestrictedDomain } from "../../utilities/Utility";
import { unitedStates } from "../../utilities/UnitedStates";
import { stripeMerchantCategories } from "../../utilities/StripeMerchantCategoryCodes";
import DatePicker from "react-datepicker";
import { AppContext } from "../../context/app/appContext";
import axios from 'axios';
import {FileDropZone} from '../common/FileDropZone';
import { toast } from 'react-toastify';

export const OrgInfo = ({ organization }) => {

    const appContext = useContext(AppContext);

    const history = useHistory();

    const entityTypes = [
        { key: 1, value: 'company', text: 'Companies, LLCs, and partnerships' },
        { key: 2, value: 'individual', text: 'Individuals and sole proprietorships' },
        { key: 3, value: 'non_profit', text: 'Non-profits' },
        { key: 4, value: 'government_entity', text: 'Government entities' },
    ];

    const signatoryTypes = [
        { key: 1, value: 'Representative', text: 'Representative' },
        { key: 2, value: 'Director', text: 'Director' },
        { key: 3, value: 'Executive', text: 'Executive' },
        { key: 4, value: 'Owner', text: 'Owner (25% or more)' },
    ];

    const stateAbbreviations = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FM": "Federated States Of Micronesia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MH": "Marshall Islands",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "MP": "Northern Mariana Islands",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
    }

    const minimumDOB = getPastDateByYears(13);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [legalEntityName, setLegalEntityName] = useState('');
    const [entityType, setEntityType] = useState(entityTypes[0].value);
    const [signatoryType, setSignatoryType] = useState(signatoryTypes[0].value);
    const [linkedInProfile, setLinkedInProfile] = useState('');
    const [primaryContactSSN, setPrimaryContactSSN] = useState('');
    const [primaryContactDOB, setPrimaryContactDOB] = useState('');
    const [website, setWebsite] = useState('');
    const [EIN, setEIN] = useState('');
    const [merchantCategoryCode, setMerchantCategoryCode] = useState('');

    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('');
    // const [unit, setUnit] = useState('');
    const [secondaryContactFirstName, setSecondaryContactFirstName] = useState('');
    const [secondaryContactLastName, setSecondaryContactLastName] = useState('');
    const [secondaryContactMobile, setSecondaryContactMobile] = useState('');
    const [secondaryContactEmail, setSecondaryContactEmail] = useState('');
    const [secondaryContactLinkedInProfile, setSecondaryContactLinkedInProfile] = useState('');

    const [pageSection, setPageSection] = useState('section-1'); // will switch between "section-1" (orgInfo, primary-contact) & "section-2" (orgAddress, secondaryContact)

    const states = unitedStates;

    const [emailError, setEmailError] = useState('');
    const [secondaryContactEmailError, setSecondaryContactEmailError] = useState('');

    const [validAddresses, setValidAddresses] = useState([]);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [verifiedStreet, setVerifiedStreet] = useState('');
    const [verifiedCity, setVerifiedCity] = useState('');
    const [verifiedState, setVerifiedState] = useState('');
    const [verifiedZip, setVerifiedZip] = useState('');
    const [verifiedCountry, setVerifiedCountry] = useState('');

    const [showSS4UploadModal, setShowSS4UploadModal] = useState(false)

    const countries = [{ key: 1, value: 'US', text: 'United States' }];

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        console.info({ merchantCategoryCode });
    }, [merchantCategoryCode]);

    useEffect(() => {
        const { status, message } = isRestrictedDomain(email);
        status ? setEmailError(message) : setEmailError('');
    }, [email]);

    useEffect(() => {
        const { status, message } = isRestrictedDomain(secondaryContactEmail);
        status ? setSecondaryContactEmailError(message) : setSecondaryContactEmailError('');
    }, [secondaryContactEmail]);

    useEffect(() => {
        setLegalEntityName(organization.legalEntityName);
        setEntityType(organization.entityType);
        setMerchantCategoryCode(organization.merchantCategoryCode || stripeMerchantCategories[0].value);
        setWebsite(organization.website);
        setEIN(organization.EIN || '');
        setStreet(organization.street);
        setCity(organization.city);
        setState(organization.state);
        setZip(organization.zip);
        setCountry(organization.country);

        setFirstName(organization.primaryContact.firstName);
        setLastName(organization.primaryContact.lastName);
        setPhoneNumber(organization.primaryContact.contactNumber === undefined ? '' : organization.primaryContact.contactNumber);
        setEmail(organization.primaryContact.email);
        setLinkedInProfile(organization.primaryContact.linkedInProfile || '');
        setSignatoryType(organization.primaryContact.signatoryType || signatoryTypes[0].value); // primary contact - Stripe Person Object (CEO/Representative etc)
        setPrimaryContactDOB((organization.primaryContact.primaryContactDOB && new Date(organization.primaryContact.primaryContactDOB)) || minimumDOB);
        setPrimaryContactSSN(organization.primaryContact.ssn || '');

        setSecondaryContactFirstName(organization.secondaryContact.firstName);
        setSecondaryContactLastName(organization.secondaryContact.lastName);
        setSecondaryContactMobile(organization.secondaryContact.contactNumber || '');
        setSecondaryContactEmail(organization.secondaryContact.email);
        setSecondaryContactLinkedInProfile(organization.secondaryContact.linkedInProfile || '');

    }, []);


    const handleSelectChange = (e, { value }) => {
        setEntityType(value);
        console.info({ value }); // TODO: strange logging EntityType gives previous value
    };

    const updateBasicOrgInfo = async (e) => {
        e.preventDefault();

        if (appContext.organization.verified) return setPageSection('section-2');

        if(street === verifiedStreet && city === verifiedCity && state === stateAbbreviations[verifiedState] && zip === verifiedZip && country === verifiedCountry){
        await appContext.setUnverifiedOrganization({
            ...organization,
            EIN,
            entityType,
            legalEntityName,
            website,
            merchantCategoryCode,
            street,
            city,
            state,
            zip,
            country,
            // primaryContact: {
            //     firstName,
            //     lastName,
            //     email,
            //     contactNumber: phoneNumber,
            //     linkedInProfile,
            //     signatoryType,
            //     primaryContactDOB,
            //     ssn: primaryContactSSN
            // },
        });
        setPageSection('section-2');
        }else{
            getVerifiedAddress()
        }
    }

    const navigateToPaymentSetup = () => {
        history.push('/account/payment-setup');
    };

    const updateOrgAdditionInfo = async (event) => {
        event.preventDefault();

        await appContext.setUnverifiedOrganization({
            ...organization,
            // street,
            // city,
            // state,
            // zip,
            // country,
            primaryContact: {
                firstName,
                lastName,
                email,
                contactNumber: phoneNumber,
                linkedInProfile,
                signatoryType,
                primaryContactDOB,
                ssn: primaryContactSSN
            },
            secondaryContact: {
                firstName: secondaryContactFirstName,
                lastName: secondaryContactLastName,
                contactNumber: secondaryContactMobile,
                email: secondaryContactEmail,
                linkedInProfile: secondaryContactLinkedInProfile,
            },
        });
        console.log("Hello")
        setPageSection('section-2');
        navigateToPaymentSetup();
    }

    // const getVerifiedAddress = async (street) => {
    //     var xmlBodyStr = `<?xml version="1.0" ?> <AccessRequest xml:lang='en-US'>
    //         <AccessLicenseNumber>FD8A17C8394CBF12</AccessLicenseNumber> <UserId>aj.perkfix</UserId>
    //         <Password>Omkar0909!!</Password>
    //         </AccessRequest>
    //         <?xml version="1.0" ?> <AddressValidationRequest xml:lang='en-US'>
    //         <Request> <TransactionReference>
    //         <CustomerContext>Your Customer Context</CustomerContext> </TransactionReference>
    //         <RequestAction>XAV</RequestAction> <RequestOption>1</RequestOption>
    //         </Request>
    //         <AddressKeyFormat>
    //         <AddressLine>`+street+`</AddressLine> <Region>`+``+`</Region>
    //         <PoliticalDivision2>`+``+`</PoliticalDivision2> <PoliticalDivision1>`+``+`</PoliticalDivision1> <PostcodePrimaryLow>`+``+`</PostcodePrimaryLow> <PostcodeExtendedLow></PostcodeExtendedLow> <CountryCode>US</CountryCode>
    //         </AddressKeyFormat> </AddressValidationRequest>`;

    //     var config = {
    //         headers: {'Content-Type': 'text/xml',
    //                     'Access-Control-Allow-Origin': '*',
    //                     'mode': 'cors',
    //                     'credentials': 'include',
    //                     'Vary': 'Accept-Encoding, Origin',
    //                     'Access-Control-Allow-Credentials': 'true'}
    //     };

    //     await axios.post('https://onlinetools.ups.com/ups.app/xml/XAV', xmlBodyStr, config).then(resp => {
    //         console.log("response form UPS = ", resp)
    //     })

    // }

    const getVerifiedAddress = async () => {
        var body = {
            "XAVRequest": {
                "AddressKeyFormat": {
                    "AddressLine": [street],
                    "Region": "", "PoliticalDivision2": city, "PoliticalDivision1": state, "PostcodePrimaryLow": zip, "PostcodeExtendedLow": "", "Urbanization": "", "CountryCode": country
                }
            }
        }

        const response = await axios.post(baseURL + '/validate-address', body)
        if (response.status === 200) {
            setValidAddresses(response.data.data.map(address => {
                return {
                    street: address.AddressKeyFormat.AddressLine,
                    city: address.AddressKeyFormat.PoliticalDivision2,
                    state: address.AddressKeyFormat.PoliticalDivision1,
                    zip: address.AddressKeyFormat.PostcodeExtendedLow.length ? address.AddressKeyFormat.PostcodePrimaryLow + '-' + address.AddressKeyFormat.PostcodeExtendedLow : address.AddressKeyFormat.PostcodePrimaryLow,
                    country: address.AddressKeyFormat.CountryCode,
                    selected: false
                }
            }))
            setShowAddressModal(true)
        }
    }

    const addressSelected = async (data, index) => {
        var addresses = validAddresses.map(address => { return { ...address, selected: false } });
        addresses[index].selected = data.checked
        setValidAddresses(addresses)
    }

    const confirmValidAddress = () => {
        const checkedAddress = validAddresses.filter(address => { return address.selected })[0]
        setVerifiedStreet(checkedAddress.street)
        setVerifiedCity(checkedAddress.city)
        setVerifiedState(checkedAddress.state)
        setVerifiedZip(checkedAddress.zip)
        setVerifiedCountry(checkedAddress.country)

        setStreet(checkedAddress.street)
        setCity(checkedAddress.city)
        setState(stateAbbreviations[checkedAddress.state])
        setZip(checkedAddress.zip)
        setCountry(checkedAddress.country)


        setShowAddressModal(false)
        setValidAddresses([])
    }

    const section1 =
        (<section>
            <form className="ui form" onSubmit={updateBasicOrgInfo}>
                <div className="orgInfo" style={{ width: '97%', marginLeft: '1.5%', marginRight: '1.5%', paddingLeft: '2%', paddingTop: '1.5%', paddingBottom: 5, marginTop: '2%', borderWidth: 1, borderColor: 'rgba(128, 149, 167, 1)', borderStyle: 'solid' }}>
                    <div style={{ marginBottom: 20 }}>
                        <span style={{ fontStyle: 'SFProText-Light', fontSize: 20, fontWeight: '100' }}>Business Profile</span>
                    </div>
                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <span style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Legal Entity Name *</span>
                        </div>
                        <div className="field eight wide">
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                type="text" onChange={e => setLegalEntityName(e.target.value)} placeholder='Your Legal Entity Name' value={legalEntityName} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Entity Type *</label>
                        </div>

                        <div className="field eight wide">
                            <Select style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                placeholder='Please select an entity type' options={entityTypes} onChange={handleSelectChange} value={entityType} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Business Category *</label>
                        </div>

                        <div className="field eight wide">
                            <Dropdown style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} placeholder='Please select a merchant category' options={stripeMerchantCategories} onChange={(e, {value}) => setMerchantCategoryCode(value)}
                                    value={merchantCategoryCode} required fluid search selection disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Website *</label>
                        </div>
                        <div className="field eight wide">
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                type="text" placeholder="Your Website (e.g. www.yourdomain.com)" onChange={e => setWebsite(e.target.value)} value={website} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>EIN / Tax ID *</label>
                        </div>
                        <div className="field eight wide">
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} type="text" placeholder="EIN / Tax ID (digits only)"
                                                                onChange={e => setEIN(e.target.value)}
                                                                value={EIN} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />EIN is not saved on our servers</div>
                        </div>
                    </div>

                    {!appContext.organization.verified && 
                    appContext.organization.stripeConnectedAccount !== undefined &&
                            (( appContext.organization.stripeConnectedAccount.requirements.currently_due.length && appContext.organization.stripeConnectedAccount.requirements.currently_due.filter(item => {return item === 'company.tax_id'}).length ) || 
                            ( appContext.organization.stripeConnectedAccount.requirements.errors.length && appContext.organization.stripeConnectedAccount.requirements.errors.filter(item => {return item.requirement === 'company.tax_id'}).length ) || 
                            ( appContext.organization.stripeConnectedAccount.requirements.eventually_due.length && appContext.organization.stripeConnectedAccount.requirements.eventually_due.filter(item => {return item === 'company.tax_id'}).length ) || 
                            ( appContext.organization.stripeConnectedAccount.requirements.past_due.length && appContext.organization.stripeConnectedAccount.requirements.past_due.filter(item => {return item === 'company.tax_id'}).length )) ?
                        <div className="inline fields" style={{ marginBottom: 10 }}>
                            <div className="field three wide">
                                <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900', color: 'red' }}>Upload SS4 *</label>
                            </div>
                            <div className="field four wide">
                            <button className="ui button" onClick={(event) => {event.preventDefault(); setShowSS4UploadModal(true)}} style={{backgroundColor: '#FCC65C'}}>Select File(s)</button>
                                {/* <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} type="text" placeholder="EIN / Tax ID (digits only)"
                                                                    onChange={e => setEIN(e.target.value)}
                                                                    value={EIN} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/> */}
                            </div>
                        </div>
                    : null}
                </div>

                <div style={{ width: '97%', marginLeft: '1.5%', marginRight: '1.5%', paddingLeft: '2%', paddingTop: '1.5%', paddingBottom: 5, marginTop: '2%', borderWidth: 1, borderColor: 'rgba(128, 149, 167, 1)', borderStyle: 'solid' }}>
                    <div style={{ marginBottom: 20 }}>
                        <span style={{ fontStyle: 'SFProText-Light', fontSize: 20, fontWeight: '100' }}>Business Address</span>
                    </div>
                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Street *</label>
                        </div>
                        <div className="field eight wide">
                            <input style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                type="text" onChange={e => {
                                    setStreet(e.target.value);
                                }} 
                                value={street} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>City *</label>
                        </div>

                        <div className="field eight wide">
                            <input type="text"
                                style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                onChange={e => setCity(e.target.value)}
                                value={city} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>State *</label>
                        </div>
                        <div className="field eight wide">
                            <Select placeholder='Please select a state'
                                    style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                    options={states}
                                    onChange={(e, {value}) => setState(value)} value={state} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Country *</label>
                        </div>
                        <div className="field eight wide">
                            <Select placeholder='Please select country'
                                    style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                    options={countries}
                                    onChange={(e, {value}) => setCountry(value)} value={country} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Zip *</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" placeholder="Zip Code (Digits only)" onChange={e => setZip(e.target.value)} value={zip} required
                                style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>
                </div>

                <footer style={{ paddingRight: '1.5%', float: 'right' }}>
                    {/* <button className="ui button" style={{marginTop: 10, backgroundColor: '#999999'}} onClick={() => getVerifiedAddress()}>Test address</button> */}
                    <button type="submit" className="ui button" style={{ marginTop: 10, backgroundColor: '#999999' }}>Next</button>
                </footer>
            </form>

            <Modal dimmer={'blurring'} open={showAddressModal} size="mini">
                {validAddresses.length ?
                    <Modal.Content>
                        <Modal.Content><p>Please select a valid address.</p></Modal.Content>
                        <p></p>
                        {validAddresses.map((address, index) => {
                            return <Modal.Content key={index}>
                                <div style={{ display: 'flex', width: '80%' }}>
                                    <div style={{ width: '90%' }}>
                                        <div>{address.street}</div>
                                        <div>{address.city}</div>
                                        <div>{address.state}, {address.zip}</div>
                                        <div>{address.country}</div>
                                    </div>
                                    <div style={{ justifyContent: 'flex-end', alignSelf: 'center', width: '10%' }}>
                                        <Checkbox checked={address.selected} onClick={(event, data) => { addressSelected(data, index) }} />
                                    </div>
                                </div>
                                <p style={{ width: '100%', height: 1, backgroundColor: 'black', marginTop: 5, marginBottom: -10 }}></p>
                            </Modal.Content>
                        })}
                    </Modal.Content>

                    :
                    <Modal.Content><p>Could not find a valid address. Please try again.</p></Modal.Content>
                }

                <Modal.Actions className="center aligned">
                    <button className="ui button" onClick={() => { setShowAddressModal(false); setValidAddresses([]) }}>Cancel</button>
                    <button className="ui button" disabled={validAddresses.filter(address => { return address.selected }).length === 0} onClick={e => { confirmValidAddress() }}>Ok</button>
                </Modal.Actions>
            </Modal>

            <Modal dimmer={'blurring'} open={showSS4UploadModal} size="small" onClose={(e) => {onCloseSS4UploadModal(e)}}>
                <Modal.Content>
                    <FileDropZone onFileGiven={(f) => handleSS4Upload(f)}/>
                    <Button className="center aligned" type="button" onClick={() => setShowSS4UploadModal(false)}>Cancel</Button>
                    <br/>
                </Modal.Content>
            </Modal>
        </section>);
    
    const onCloseSS4UploadModal = async (e) => {
        e.preventDefault();
        setShowSS4UploadModal(false);
    };

    const handleSS4Upload = async (file) => {
        setShowSS4UploadModal(false);
        appContext.setLoading(true);
        console.info({file})
        const formData = new FormData();
        formData.append("file", file);
        // formData.append('accountId', appContext.organization.stripe.accountId)

        const uploaded = await axios.post(`${baseURL}/organization/upload-ss4`, formData, {
            headers: { Authorization: `Bearer ${accessToken}` }
          });
        console.info({uploaded});

        if (!uploaded) return csvFailed();

        // const {code, message, data} = uploaded;
        // if (!(code && message)) return csvFailed();

        appContext.setLoading(false);

        if(uploaded.status === 200){
            toast.success(`SS4 uploaded successfully. Verification could take up to 48 hours. Please check back after some time.`, {autoClose: 3000});
        }else toast.error(`Error uploading file. Please try again.`, {autoClose: 3000});
    }

    const csvFailed = () => {
        appContext.setLoading(false);
        toast.error(`Error uploading file. Please try again.`, {autoClose: 3000});
        return null;
    }

    const showFirstSection = async (e) => {
        e.preventDefault();
        if (!appContext.organization.verified) {
            await appContext.setUnverifiedOrganization({
                ...organization,
                // street,
                // city,
                // state,
                // zip,
                // country,
                primaryContact: {
                    firstName,
                    lastName,
                    email,
                    contactNumber: phoneNumber,
                    linkedInProfile,
                    signatoryType,
                    primaryContactDOB,
                    ssn: primaryContactSSN
                },
                secondaryContact: {
                    firstName: secondaryContactFirstName,
                    lastName: secondaryContactLastName,
                    contactNumber: secondaryContactMobile,
                    email: secondaryContactEmail,
                    linkedInProfile: secondaryContactLinkedInProfile,
                },
            });
        }
        setPageSection('section-1');
    }

    const section2 =
        (<section>
            {/* <h3>Address of your company’s HQ</h3>
            <hr/> */}
            <form className="ui form" onSubmit={updateOrgAdditionInfo}>
                <div style={{ width: '97%', marginLeft: '1.5%', marginRight: '1.5%', paddingLeft: '2%', paddingTop: '1.5%', paddingBottom: 5, marginTop: '2%', borderWidth: 1, borderColor: 'rgba(128, 149, 167, 1)', borderStyle: 'solid' }}>
                    <div style={{ marginBottom: 20 }}>
                        <span style={{ fontStyle: 'SFProText-Light', fontSize: 20, fontWeight: '100' }}>Primary Contact Details</span>
                    </div>
                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>First Name*, Last Name*</label>
                        </div>
                        <div className="field four wide">
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                type="text" placeholder="First Name" onChange={e => setFirstName(e.target.value)} value={firstName} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                        <div className="field four wide">
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                type="text" placeholder="Last Name" onChange={e => setLastName(e.target.value)} value={lastName} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Contact Number *</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" placeholder="Work Mobile Number (digits only)"
                                style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                onChange={e => setPhoneNumber(e.target.value)}
                                value={String(phoneNumber)} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Contact Email *</label>
                        </div>
                        <div className={emailError.length ? 'error field eight wide' : 'field eight wide'}>
                            <input type="email" placeholder="Your work email address" 
                                style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                onChange={e => setEmail(e.target.value)} value={email} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                            {emailError && (<span className="input-field-error">{emailError}</span>)}
                        </div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />Work email only</div>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Contact SSN *</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" placeholder="Your SSN (digits only)" onChange={e => setPrimaryContactSSN(e.target.value)} value={primaryContactSSN} required
                                                                style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                                                disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/></div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />Need this for compliant and KYC</div>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Date of Birth *</label>
                        </div>
                        <div className='field eight wide'>
                            <DatePicker disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25} className="ui input fluid dob" maxDate={minimumDOB} onChange={date => setPrimaryContactDOB(date)}
                                        style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                        selected={primaryContactDOB}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>LinkedIn Profile *</label>
                        </div>
                        <div className="field eight wide">
                            <input placeholder="Linkedin profile URL" type="text" onChange={e => setLinkedInProfile(e.target.value)} value={linkedInProfile} required
                                    style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                    disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/></div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />Need this for compliant and KYC</div>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Signatory Type *</label>
                        </div>
                        <div className="field eight wide">
                            <Select placeholder='Please select a signatory type'
                                    style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                    options={signatoryTypes}
                                    onChange={(e, {value}) => (setSignatoryType(value))}
                                    value={signatoryType} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                            <i className="info circle icon large"/>
                        </div>
                    </div>
                </div>

                <div style={{ width: '97%', marginLeft: '1.5%', marginRight: '1.5%', paddingLeft: '2%', paddingTop: '1.5%', paddingBottom: 5, marginTop: '2%', borderWidth: 1, borderColor: 'rgba(128, 149, 167, 1)', borderStyle: 'solid' }}>
                    <div style={{ marginBottom: 20 }}>
                        <span style={{ fontStyle: 'SFProText-Light', fontSize: 20, fontWeight: '100' }}>Secondary Contact Details</span>
                    </div>
                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>First Name *, Last Name *</label>
                        </div>

                        <div className="field four wide">
                            <input type="text"
                                style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                placeholder="First Name"
                                onChange={e => setSecondaryContactFirstName(
                                    e.target.value)}
                                value={secondaryContactFirstName} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                        <div className="field four wide">
                            <input type="text"
                                style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                placeholder="Last Name"
                                onChange={e => setSecondaryContactLastName(
                                    e.target.value)}
                                value={secondaryContactLastName} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>

                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />We will reach out to this contact in case we are unable to reach the primary contact. Can, update or approve
                                perk budget. Will be contacted for invoices.
                            </div>
                        </div>

                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Contact Number *</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" placeholder="Work Mobile Number (digits only)" onChange={e => setSecondaryContactMobile(e.target.value)} value={secondaryContactMobile} required
                                style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}}
                                disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>Contact Email *</label>
                        </div>
                        <div className={secondaryContactEmailError.length ? 'error field eight wide' : 'field eight wide'}>
                            <input style={{backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0}} 
                                type="email" placeholder="Work email address" onChange={e => setSecondaryContactEmail(e.target.value)} value={secondaryContactEmail} required disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                            {secondaryContactEmailError && (<span className="input-field-error">{secondaryContactEmailError}</span>)}
                        </div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />Work email only</div>
                        </div>
                    </div>

                    <div className="inline fields" style={{ marginBottom: 10 }}>
                        <div className="field three wide">
                            <label style={{ fontStyle: 'SFProText-Bold', fontSize: 14, fontWeight: '900' }}>LinkedIn Profile </label>
                        </div>
                        <div className="field eight wide">
                            <input style={{ backgroundColor: 'transparent', borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderBottomColor: 'rgba(128, 149, 167, 1)', borderRadius: 0 }}
                                type="text" placeholder="Linkedin profile URL" onChange={e => setSecondaryContactLinkedInProfile(e.target.value)} value={secondaryContactLinkedInProfile} required
                                disabled={appContext.organization.verified || localStorage.getItem('accessToken').length > 25}/>
                        </div>
                        <div className="field five wide">
                            <div className="ui label"><i className="info circle icon large" />Need this for compliant and KYC</div>
                        </div>
                    </div>
                </div>

                <footer style={{ paddingRight: '1.5%', float: 'right' }}>
                    <button className="ui button" onClick={showFirstSection} style={{ marginTop: 10, backgroundColor: '#999999' }}>Back</button>
                    {!appContext.organization.verified ? (<button type="submit" className="ui button" style={{ marginTop: 10, backgroundColor: '#999999' }}>Next</button>) : ''}
                </footer>
            </form>
        </section>);

    const currentPageSection = pageSection === 'section-1' ? section1 : section2;

    return (
        <div className="sub-page" id="org-info">{currentPageSection}</div>
    );
};
